export default __webpack_public_path__ + "static/media/whitePlus.20be1f34.svg";